import { useState } from "react";
import classNames from "classnames";
import { HiOutlineCog } from "react-icons/hi";

import ModalSmartStowSettings from "./modals/ModalSmartStowSettings";

export default function SmartStowSettings({ system }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <button
                className={classNames(
                    "flex justify-center items-center gap-2 bg-white text-sm py-2 px-4 border border-sky-600 rounded",
                    "text-sky-600 hover:text-sky-950 hover:border-sky-950"
                )}
                onClick={() => setIsModalOpen(true)}
            >
                <HiOutlineCog fontSize={24} />
                Settings
            </button>

            <ModalSmartStowSettings
                system={system}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            />
        </>
    );
}
